import { createSlice } from "@reduxjs/toolkit";
import { constants } from "@qgiv/core-js";
import { config as initialState } from "../initialState";

export const slice = createSlice({
    name: "config",
    initialState: {
        ...initialState,
        isCms: !!constants.cms,
    },
    reducers: {},
});

// selectors

// Same as getConfig
export const selectConfig = (state) => state.config;

export const selectIsCms = (state) => state.config.isCms;

export const selectHTTP = (state) => state.config.HTTP_HOST;

export default slice.reducer;
